export default __webpack_public_path__ + "static/media/2728 spice rack top.1ad1eb57.png";